import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import cookie from 'react-cookies';
import EmailSent from 'assets/images/product-development-guide/email-sent.svg';
import { Link, Button, Paragraph, Heading, Image } from 'components';
import { serialize } from '../../utils';
import './EbookForm.scss';

class EbookForm extends Component {
  constructor() {
    super();

    this.refForm = createRef();

    this.state = {
      subscribed: false,
    };
  }

  handleSubmit = e => {
    e.preventDefault();

    const { url } = this.props;
    const userId = '?visitor_id=' + cookie.load('visitor_id688533');
    const formUrl = url.concat(userId);
    const form = this.refForm.current;

    fetch(formUrl, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json'
      },
      body: serialize(form),
    })
      .then(() => {
        if (typeof window !== 'undefined' && window.fbq && typeof window.fbq === 'function') {
          window.fbq('track', 'Download');
        }
        this.setState({ subscribed: true });
      })
      .catch(error => console.log(error));
  };

  render() {
    const {
      type,
      button,
    } = this.props;
    const { subscribed } = this.state;

    return (
      <div className={'ebook-form'}>
        {subscribed ? (
          <div className={'ebook-form--sent'}>
            <Image src={EmailSent} additionalClass={'ebook-form__icon-sent'} />
            <Paragraph size={'medium'} type={2} additionalClass={'text--bold'}>
              Thank You for filling up the form!
            </Paragraph>
            <Paragraph
              size={'medium'}
              additionalClass={'text--light ebook__desciption'}
            >
              Your {type} was sent to your e-mail. Have fun reading it!
            </Paragraph>
            <Link to={'/blog/'} additionalClass={'ebook-form__headline--long'}>
              <Button
                id={'ebook-go-home'}
                color={'white'}
                additionalClass={'ebook-form__button--home'}
              >
                Visit our blog
              </Button>
            </Link>
          </div>
        ) : (
          <>
            <Heading
              size={'medium'}
              type={2}
              additionalClass={'ebook-form__headline'}
            >
              Get your free {type} now
            </Heading>
            <form
              className={'ebook-form__inputs'}
              onSubmit={this.handleSubmit}
              ref={this.refForm}
            >
              <input type={'text'} name={'name'} placeholder={'Name'} required />
              <input
                type={'text'}
                name={'lastName'}
                placeholder={'Last Name'}
                required
              />
              <input
                type={'email'}
                name={'email'}
                placeholder={'E-mail'}
                required
              />
              <input
                type={'text'}
                name={'job'}
                placeholder={'Job title'}
                required
              />
              <Button
                id={'ebook-form-submit'}
                type={'submit'}
                color={'white'}
                additionalClass={'ebook-form__button'}
              >
                {button}
              </Button>
            </form>
            <Paragraph additionalClass={'ebook-form__info text--light'}>
              {
                "We're committed to your privacy. Boldare uses the information you provide to us to contact you about our relevant content, products, and services."
              }
              {' Read our '}
              <Link to={'/privacy-policy/'} id={'ebook-form-privacy-policy'}>
                privacy policy.
              </Link>
            </Paragraph>
          </>
        )}
      </div>
    );
  }
}

EbookForm.propTypes = {
  short: PropTypes.bool,
  button: PropTypes.string,
  url: PropTypes.string,
  type: PropTypes.string,
};

EbookForm.defaultProps = {
  short: false,
};

export default EbookForm;
